
export class SearchToolbarModel {
  elapsed_start: Date;
  elapsed_end: Date;
  clusters: any[];
  card_mode: any;
  group_type: any;
  group_type_code: any;
  groups: any[];
  area: any;
  stores: any[];
  sectors?: { depth: number, sectors: any[] };
  promotions?: number;
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/searchToolBar/search-toolbar.model.ts